import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RenderOnAuthenticated } from "./components/RenderOnAuthenticated/RenderOnAuthenticated";
import LandingPage from "./pages/LandingPage";
import { Main } from "./components/Main/Main";
import Applications from "./pages/Applications";
import Objects from "./pages/Objects";
import CustomDataType from "./pages/CustomDataType";
import Rule from "./pages/Rule";
import { ProcessDesigner } from "./pages/ProcessDesigner/ProcessDesigner";
import ConnectedSystem from "./pages/ConnectedSystem";
import HttpIntegration from "./pages/HttpIntegration";
import Administration from "./pages/Administration";
import RecordType from "./pages/RecordType";
import WebApi from "./pages/WebApi";
import { ApplicationsLayout } from "./pages/Applications/ApplicationsLayout";
import { ObjectsLayout } from "./pages/Objects/ObjectsLayout";
import { MonitorLayout } from "./pages/Monitor/MonitorLayout";
import { Profile } from "./pages/Profile/Profile";

/* eslint-disable-next-line */
export interface IAppRouterProps {}

export const AppRouter: React.FC<IAppRouterProps> = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/profile"
          element={
            <RenderOnAuthenticated>
              <Profile />
            </RenderOnAuthenticated>
          }
        />
        <Route
          path="/platform/"
          element={
            <RenderOnAuthenticated>
              <Main />
            </RenderOnAuthenticated>
          }
        >
          <Route path="design/applications" element={<ApplicationsLayout />} />
          <Route
            path="design/objects/:applicationId"
            element={<ObjectsLayout />}
          />
          <Route path="design/objects" element={<ObjectsLayout />} />
          <Route
            path="design/custom-data-type/:cdtId"
            element={<CustomDataType />}
          />
          <Route
            path="design/connected-system/:csId"
            element={<ConnectedSystem />}
          />
          <Route path="design/record-type/:rtId" element={<RecordType />} />
          <Route
            path="design/http-integration/:intgId"
            element={<HttpIntegration />}
          />
          <Route path="design/web-api/:webApiId" element={<WebApi />} />
          <Route path="design/rule/:ruleId" element={<Rule />} />
          <Route
            path="design/process/:processId"
            element={<ProcessDesigner />}
          />
          <Route
            path="design/process-instance/:processId/:processInstanceId"
            element={<ProcessDesigner isInstanceBased={true} />}
          />
          <Route path="design/monitor" element={<MonitorLayout />} />
          <Route path="admin/administration" element={<Administration />} />

          <Route path="*" element={<div>Not Found</div>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
